import { wirelessBreadcrumbsConfig } from '../core/breadcrumbs/breadcrumbs.config';
import { RouteBreadcrumbsConfig } from '../core/breadcrumbs/breadcrumbs.model';

const manageSimHeader = 'manage-sim.header';
const manageSim = 'manage-sim';

const routeBreadcrumbConfig = (copy, val = null, alt = '') => [
  {
    alt,
    copy,
    val,
  },
];

const manageSimRouteBreadcrumbsConfigs = [
  wirelessBreadcrumbsConfig,
  ...routeBreadcrumbConfig(manageSimHeader, manageSim),
];

const manageSimBreadcrumbsConfig: RouteBreadcrumbsConfig = {
  breadcrumbsData: [wirelessBreadcrumbsConfig, ...routeBreadcrumbConfig(manageSimHeader)],
  useRegEx: true,
  regexp: /(^manage-sim$)|(^manage-sim\/error$)/,
};

const activateEsimBreadcrumbsConfig: RouteBreadcrumbsConfig = {
  breadcrumbsData: [
    ...manageSimRouteBreadcrumbsConfigs,
    ...routeBreadcrumbConfig('manage-sim.activate-esim.breadcrumb'),
  ],
  useRegEx: false,
  key: `${manageSim}/setup-esim`,
};

const changeSimBreadcrumbsConfig: RouteBreadcrumbsConfig = {
  breadcrumbsData: [...manageSimRouteBreadcrumbsConfigs, ...routeBreadcrumbConfig('manage-sim.change-my-sim')],
  useRegEx: false,
  key: `${manageSim}/change-sim`,
};

const otpVerificationBreadcrumbsConfig: RouteBreadcrumbsConfig = {
  breadcrumbsData: [...manageSimRouteBreadcrumbsConfigs, ...routeBreadcrumbConfig('manage-sim.security-verification')],
  useRegEx: true,
  regexp: /(^manage-sim\/otp-(send|verification)$)/,
};

export const manageSimBreadcrumbsConfigs: RouteBreadcrumbsConfig[] = [
  activateEsimBreadcrumbsConfig,
  changeSimBreadcrumbsConfig,
  manageSimBreadcrumbsConfig,
  otpVerificationBreadcrumbsConfig,
];
